module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Tickets")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  cerrados ")]), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v(" " + _vm._s(_vm.tipo && _vm.tipo.toLowerCase()) + " (Duración en dias y horas)")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Listado general de tickets cerrados ordenados por duracion")])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.lineChart.fetchTicketsCerrados()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v("Actualizar")], 1)], 1), _c('v-divider'), (_vm.count) ? _c('div', {
    staticClass: "d-flex mx-1"
  }, [_c('div', {
    staticClass: "flex-1 ma-2"
  }, [_c('v-card', {
    staticClass: "pa-2 text-xs-center elevation-1",
    attrs: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center jc-center fd-column"
  }, [_c('div', {
    staticClass: "display-1 font-weight-700"
  }, [_vm._v(_vm._s(_vm.cantidadTicketsCerrados))]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Total de tickets")])])])], 1)]) : _vm._e(), (_vm.renderChart) ? _c('line-chart', {
    ref: "lineChart",
    attrs: {
      "tipo": _vm.tipo,
      "desde": _vm.desde,
      "hasta": _vm.hasta
    },
    on: {
      "count": _vm.obtenerCantidad
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ca5a3f5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_card_chart_line_tickets_cerrados_por_horas_activo.vue
// module id = 516
// module chunks = 1